import { AUDIO_CONFIG } from './constants';

// Audio chunk cache with metadata
const audioCache = new Map();

// Cache utilities with better metadata
export const getCachedAudio = (cacheKey) => audioCache.get(cacheKey);

export const setCachedAudio = (cacheKey, data) => {
  if (audioCache.size >= AUDIO_CONFIG.CACHE_SIZE_LIMIT) {
    const firstKey = audioCache.keys().next().value;
    audioCache.delete(firstKey);
  }
  audioCache.set(cacheKey, {
    url: data.url,
    startTime: data.startTime,
    timestamp: Date.now()
  });
};

export const clearAudioCache = () => {
  audioCache.clear();
};

export const getCacheSize = () => audioCache.size;
